import { Box } from '@forgeglobal/design-framework'
import React from 'react'

export const RightAlign: React.FC = ({ children }) => <Box textAlign="right">{children}</Box>

export default RightAlign
